import { Dispatch } from "redux";
import api from "../../api/api";
import { setAverageScore, resetAverageScore } from "../reducers/getOverallPerformanceScoreByTeacherReducer";

// const getOverallPerformanceScoreByTeacher = ( teacher_id:any , token: any ,periodTab:any,selectedcourselist: any[],students:any[], year:any,month:any , start_date :any ,end_date:any) => async (   ////if costum add these two: , start_date:any, end_date:any 
const getOverallPerformanceScoreByTeacher = (token: any, data: any) => async (   ////if costum add these two: , start_date:any, end_date:any 
    dispatch: Dispatch
) => {

    try {
        const result = await api.get(`/analytics/dashboard/teacher/get-average-score/`, {
            params: {
                ...data
            },
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${token}`,
            },
        });

        if (result) {
            dispatch(setAverageScore(result?.data || []))
        }
    } catch (error: any) {
        console.error("Error fetching course list:", error);
    }
}

//};

export { getOverallPerformanceScoreByTeacher, resetAverageScore };


